// extracted by mini-css-extract-plugin
export default {"headingHeader":"_17DUw","headinHeaderValue":"_1nmSu","backMargin":"_20VU4","backIcon":"_3gyis","mainPadding":"zex89"};